module.exports = __webpack_public_path__ + "static/Custom_Communication_sys_image-86f77e2cc1fbdc945b031323b2052d6a.png";